import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import moment from 'moment';

const messages = defineMessages({
  countdownMessage: {
    id: 'countdown_message',
    defaultMessage: 'Selezionare una data di scadenza per il countdown',
  },
  days: {
    id: 'countdown_days',
    defaultMessage: 'giorni',
  },
  hours: {
    id: 'countdown_hours',
    defaultMessage: 'ore',
  },
  minutes: {
    id: 'countdown_minutes',
    defaultMessage: 'minuti',
  },
  seconds: {
    id: 'countdown_seconds',
    defaultMessage: 'secondi',
  },
  expired: {
    id: 'countdown_expired',
    defaultMessage: 'Coutdown scaduto il giorno',
  },
  expiredHours: {
    id: 'expiredHours',
    defaultMessage: 'alle ore',
  },
});

const viewDate = (locale, value, format) => {
  //  Used to set a server timezone or UTC as default
  moment.updateLocale(locale, moment.localeData(locale)._config); // copy locale to moment-timezone
  let datetime = null;

  if (value) {
    if (typeof value == 'string') {
      // check if datetime has timezone, otherwise assumes it's UTC
      datetime = value.match(/T(.)*(-|\+|Z)/g)
        ? // Since we assume UTC everywhere, then transform to local (momentjs default)
          moment(value)
        : value.match(/T(.)/g)
        ? moment(`${value}Z`) // This might happen in old Plone versions dates
        : moment(value); //This when date is like '2021-05-05'
    } else {
      datetime = moment(value);
    }
  }

  if (format && datetime) {
    return datetime.format(format);
  }
  return datetime;
};

const calculateTimeLeft = (end, intl) => {
  const endDate = viewDate(intl.locale, end);
  let difference = +endDate - +new Date();

  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: {
        value: Math.floor(difference / (1000 * 60 * 60 * 24)),
        label: intl.formatMessage(messages.days),
      },
      hours: {
        value: Math.floor((difference / (1000 * 60 * 60)) % 24),
        label: intl.formatMessage(messages.hours),
      },
      minutes: {
        value: Math.floor((difference / 1000 / 60) % 60),
        label: intl.formatMessage(messages.minutes),
      },
      seconds: {
        value: Math.floor((difference / 1000) % 60),
        label: intl.formatMessage(messages.seconds),
      },
    };
  }

  return timeLeft;
};

const CountDown = ({
  end,
  showHours = true,
  showMinutes = true,
  showSeconds = true,
}) => {
  const intl = useIntl();

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(end, intl));

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(end, intl));
    }, 1000);
    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval, i) => {
    if (
      !timeLeft[interval].value &&
      (timerComponents?.length === 0 || i === Object.keys(timeLeft) - 1)
    ) {
      return;
    }
    if (
      (interval === 'hours' && !showHours) ||
      (interval === 'minutes' && !showMinutes) ||
      (interval === 'seconds' && !showSeconds)
    ) {
      return;
    }
    timerComponents.push(
      <div className={'interval ' + interval} key={'interval ' + interval}>
        <div className="number">
          {(interval === 'minutes' || interval === 'seconds') &&
          timeLeft[interval].value < 10
            ? '0'
            : ''}
          {timeLeft[interval].value}
        </div>
        <span className="label">{timeLeft[interval].label}</span>
      </div>,
    );
  });

  return (
    <div className="count-down-timer">
      {timerComponents.length ? (
        timerComponents
      ) : (
        <div className="expired">
          {end ? (
            <>
              {intl.formatMessage(messages.expired)}{' '}
              {viewDate(intl.locale, end, 'DD/MM/YYYY')}{' '}
              {intl.formatMessage(messages.expiredHours)}{' '}
              {viewDate(intl.locale, end, 'HH:mm')}
            </>
          ) : (
            intl.formatMessage(messages.countdownMessage)
          )}
        </div>
      )}
    </div>
  );
};

export default CountDown;
